import { useQuery } from '@tanstack/react-query';
import { useShallow } from 'zustand/shallow';
import { useAuthStore } from '@/lib/auth';
import { QUERY_PRESETS } from '@/lib/query';
import { fetchMe, fetchMeMemberships } from './api';
import { meQueryKeys } from './key';
export { fetchMe, fetchMeMemberships } from './api';
export type { MeIdentity, MeMembershipItem, MeMembershipsResponse, MeResponse } from './type';
const FIVE_MINUTES = 5 * 60 * 1000;
export const useMe = () => {
  const session = useAuthStore(useShallow(({
    session
  }) => session));
  return useQuery({
    queryKey: meQueryKeys.all,
    queryFn: fetchMe,
    enabled: !!session,
    staleTime: FIVE_MINUTES
  });
};
export const useMeMemberships = () => {
  const session = useAuthStore(useShallow(({
    session
  }) => session));
  return useQuery({
    queryKey: meQueryKeys.memberships(),
    queryFn: fetchMeMemberships,
    enabled: !!session,
    ...QUERY_PRESETS.list()
  });
};